import "./App.scss";
import Advice from "./components/Advice";

function App() {
  return (
    <main>
      <Advice />
    </main>
  );
}

export default App;
